import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { useServerDebug } from "./DebugContext";
import { formatApiError } from "./apiError";
import "./login.css";

export default function Login() {
  const { login, error, setError } = useAuth();
  const serverDebug = useServerDebug();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(formatApiError(err, serverDebug));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>Finance suite</h1>
        <p className="login-sub">Sign in with your finance_db account.</p>
        <form onSubmit={submit} className="login-form">
          <label>
            Email or username
            <input
              type="text"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label>
            Password
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          {error && <div className="login-error">{error}</div>}
          <button type="submit" disabled={busy} className="login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

      </div>
    </div>
  );
}
